import { Component, OnInit } from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {Globals} from '../../globals';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor( private cookieService: CookieService,
               public globals: Globals) { }

  ngOnInit() {
  }

  public createApp(){
    this.globals.isCreateApplication = !this.globals.isCreateApplication;
  }

  public logout(){
    this.cookieService.delete("UVMAppLoggedInToken");
    window.location.reload();
  }

  public toggleApplications() {
    this.globals.allApplications = !this.globals.allApplications;
  }

}
